import { ensure } from '@vrplatform/utils';
import type { user_bool_exp } from '@vrplatform/graphql';
import { z } from 'zod';

const ownersFilterInput = {
  search: z.string().optional().nullable(),
  type: z.enum(['individual', 'company']).optional().nullable(),
  status: z
    .enum(['inactive', 'active', 'unconfirmed', 'archived'])
    .optional()
    .nullable(),
};

const ownersFilter = z.object(ownersFilterInput);

type OwnersFilterParams = z.infer<typeof ownersFilter>;

type BaseWhere = {
  teamId: string;
  GL: boolean;
};

export function whereOwnerUsers({
  search: s,
  teamId,
  type,
  status,
  GL,
}: BaseWhere & OwnersFilterParams) {
  const search = s?.trim();
  const searchQuery = search
    ? ensure<user_bool_exp[]>([
        { name: { _ilike: `%${search}%` } },
        { firstName: { _ilike: `%${search}%` } },
        { lastName: { _ilike: `%${search}%` } },
        { address: { _ilike: `%${search}%` } },
        { companyName: { _ilike: `%${search}%` } },
        { email: { _ilike: `%${search}%` } },
        { phone: { _ilike: `%${search}%` } },
        {
          ownerships: {
            listing: {
              name: { _ilike: `%${search}%` },
            },
          },
        },
        {
          ownerships: {
            listing: {
              address: { _ilike: `%${search}%` },
            },
          },
        },
      ])
    : undefined;

  return ensure<user_bool_exp>({
    memberships: {
      tenantId: { _eq: teamId },
      role: { _eq: 'owner' },
      status: status
        ? {
            _eq: status,
          }
        : undefined,
    },
    // TODO: @LarsBehrenberg GL - update this to use contactAccesses
    ownerAccesses: type
      ? {
          owner: GL
            ? undefined
            : {
                type: { _eq: type },
                tenantId: { _eq: teamId },
              },
          contact: GL
            ? {
                tenantId: { _eq: teamId },
                companyType: { _is_null: type === 'individual' },
              }
            : undefined,
        }
      : undefined,
    _or: searchQuery,
  });
}
